import { render, staticRenderFns } from "./NotificationObstacleDetectionQuestionnaireQuestion.vue?vue&type=template&id=79963778&scoped=true&"
import script from "./NotificationObstacleDetectionQuestionnaireQuestion.vue?vue&type=script&lang=ts&"
export * from "./NotificationObstacleDetectionQuestionnaireQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationObstacleDetectionQuestionnaireQuestion.vue?vue&type=style&index=0&id=79963778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79963778",
  null
  
)

export default component.exports